import React from 'react';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import Text from '../text/Text';


const TextInputError = ({ error }) => {
	const styles = useThemedStyles(createStyles);

	if (!error) {
		return null;
	}

	return (
		<Text style={styles.errorWrapper}>
			{error}
		</Text>
	);
};

const createStyles = ({ ui: { colors, type } }) => ({
	errorWrapper: {
		...type.secondaryStrong,
		paddingTop: 0,
		paddingBottom: 5,
		color: colors.danger,
	},
});

export default TextInputError;
